





















import { Component, Vue, Watch } from 'vue-property-decorator';
import WidgetUser from '../WidgetUser.vue';
import { LoadingService } from '@/services/loadingService';
import { Funcionalidades } from '../../../config/funcionalidades';
import { Snotify } from '@/snotify/Snotify';
import Analitica from '@/pantallas/SucursalVirtual/analitica_uso';

import { fetchMantenedorCapacitaciones } from './fetchMantenedorCapacitaciones';
import ModalCapacitaciones from './ModalCapacitaciones.vue';

import { CategoriasApi, ItemsApi } from './models/Capacitaciones.model';

@Component({
  components: {
    ModalCapacitaciones,
    WidgetUser,
  },
})
export default class CapacitacionesBase extends Vue {
  readonly funcionalidad: Funcionalidades = Funcionalidades.capacitaciones;
  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();
  analytic = new Analitica(203, window.location.href);

  activeBtn: number = 0;
  dialog: boolean = false;
  categoria: number = 0;
  loading: boolean = false;
  data: CategoriasApi[] = [];
  items: ItemsApi[] = [];

  async mounted() {
    let entrada = await this.analytic.entrada();
    this.data = await this.getCategorias();
    this.items = await this.getItems();
  }
  async destroyed() {
    let salida = await this.analytic.salida(this.analytic.id_analitica);
  }

  showModal(categoria: string) {
    const categoriaInt: number = Number(categoria);
    if (this.activeBtn === categoriaInt) {
      this.dialog = !this.dialog;
      this.activeBtn = 0;
    } else {
      this.activeBtn = categoriaInt;
      this.dialog = true;
    }
    this.categoria = categoriaInt;
  }

  async getCategorias(): Promise<CategoriasApi[]> {
    this.loading = true;
    this.loadingService.showLoading();
    return await fetchMantenedorCapacitaciones({})
      .then(resp => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, LISTA } = resp.data;
        const cod: number = Number(CODIGO_RESPUESTA);

        if (cod !== 1 || MENSAJE_RESPUESTA) {
          this.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
          return [];
        }
        return LISTA;
      })
      .catch((err: Error) => {
        this.$snotify.error(
          'Ha ocurrido un error inesperado, por favor reintente más tarde',
          { timeout: 3000 }
        );
        throw err;
      })
      .finally(() => this.loadingService.hideLoading());
  }

  async getItems(): Promise<ItemsApi[]> {
    this.loadingService.showLoading();
    return await fetchMantenedorCapacitaciones({ endpoint: 'get_items' })
      .then(resp => {
        const { CODIGO_RESPUESTA, MENSAJE_RESPUESTA, LISTA } = resp.data;
        const cod: number = Number(CODIGO_RESPUESTA);
        if (cod !== 1 || MENSAJE_RESPUESTA) {
          this.$snotify.error(MENSAJE_RESPUESTA, { timeout: 3000 });
          return [];
        }
        return LISTA;
      })
      .catch((err: Error) => {
        this.$snotify.error(
          'Ha ocurrido un error inesperado, por favor reintente más tarde',
          { timeout: 3000 }
        );
        throw err;
      })
      .finally(() => {
        this.loadingService.hideLoading();
        this.loading = false;
      });
  }
}
